module.exports = __webpack_public_path__ + "static/media/clem-onojegaw.c058841b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/examples/clem-onojegaw.jpg
// module id = 5864
// module chunks = 0